import { useMutation, useQueryClient } from '@tanstack/react-query';

import { assignRenewal } from '../api/AssignRenewal';

interface AssignRenewalsParams {
  renewalUuid: string;
}

export const useAssignRenewals = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ renewalUuid }: AssignRenewalsParams) =>
      assignRenewal(renewalUuid),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['renewals'] });
      queryClient.invalidateQueries({
        queryKey: ['renewal', variables.renewalUuid],
      });
    },
  });

  return {
    assign: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
